import { store } from "infrastructure/store/ConfigureStore";
import {
  setGridUrlParams,
  resetGridPaginationUrlParams,
} from "infrastructure/store/dataGrid/DataGridActions";
import IDataFilterService from "./IDataFilterService";
import { injectable } from "inversify";
import IUrlParam from "./IUrlParam";
import { DataGridId } from "../dataGrid/DataGridId";
import {
  Contracts_Route,
  Invoices_Route,
  Payments_Route,
  ProformaInvoices_Route,
  Requirements_Route,
  DepositAgreement_Route,
} from "features/shared/router/routes/routes";

@injectable()
export default class DataFilterService implements IDataFilterService {
  storeSetParams(
    dataGridId: string,
    newParams?: IUrlParam[],
    currentParams?: URLSearchParams
  ): void {
    if (newParams?.length === 0 && !currentParams) return;

    const urlSearchParams = this.setUrlSearchParams(newParams, currentParams);
    this.storeDataGridSettings(dataGridId, urlSearchParams);
    this.storeResetPagination(dataGridId);
  }

  getGridIdByRoute(route: string): DataGridId | undefined {
    if (!route) return;

    const mapping = new Map<string, DataGridId>();
    mapping.set(Payments_Route, DataGridId.paymentGrid);
    mapping.set(Invoices_Route, DataGridId.invoiceGrid);
    mapping.set(Requirements_Route, DataGridId.requirementGrid);
    mapping.set(Contracts_Route, DataGridId.contractGrid);
    mapping.set(ProformaInvoices_Route, DataGridId.proformaInvoicesGrid)
    mapping.set(DepositAgreement_Route, DataGridId.depositAgreementGrid)

    return mapping.get(route);
  }

  private setUrlSearchParams = (
    newParams?: IUrlParam[],
    currentParams?: URLSearchParams
  ): URLSearchParams => {
    const urlParams = new URLSearchParams(currentParams ?? "");

    if (newParams !== undefined && newParams?.length > 0) {
      newParams.forEach((value) => {
        if (value.append) {
          urlParams.append(value.key, value.value);
        } else {
          urlParams.set(value.key, value.value);
        }
      });
    }

    return urlParams;
  };

  private storeDataGridSettings(
    dataGridId: string,
    params: URLSearchParams
  ): void {
    store.dispatch(
      setGridUrlParams({ key: dataGridId, value: params.toString() })
    );
  }

  private storeResetPagination(dataGridId: string): void {
    store.dispatch(resetGridPaginationUrlParams(dataGridId));
  }
}
